module.exports = __webpack_public_path__ + "img/04-Pic-kids.60c023c5.png";